import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Text, View } from 'react-native'
import { colors } from '../styles'
import { checkHyphenation } from '../utils'

const pageTitleStyle = {
  color: colors.white,
  fontWeight: 'bold',
  textAlign: 'center',
}

const getPageTitleStyle = (size) => {
  let fontSize = 21
  if (size === 'large') {
    fontSize = 24
  } else if (size === 'small') {
    fontSize = 19
  }
  return [pageTitleStyle, { fontSize }]
}

function NavigationTitle({
 path, t, titleStyle, widthStyle,
}) {
  const width = (widthStyle === 'large' ? 300 : 250)
  return (
    <View style={{
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      width,
    }}
    >
      <Text
        maxFontSizeMultiplier={1}
        numberOfLines={2}
        style={getPageTitleStyle(titleStyle)}
      >
        {checkHyphenation(t(path))}
      </Text>
    </View>
  )
}

NavigationTitle.propTypes = {
  path: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  titleStyle: PropTypes.string,
  widthStyle: PropTypes.string,
}

NavigationTitle.defaultProps = {
  titleStyle: null,
  widthStyle: null,
}

export default withTranslation()(NavigationTitle)
